import { get, post } from './common'

export namespace order {
  // 定价套餐
  export function getPlanList() {
    return get<
      ApiTypes.DataResult<{
        activityInfo: ServerData.ActivityInfo
        planList: ServerData.OrderPlan[]
      }>
    >('/order/plan', {})
  }

  // 创建订单
  export function createOrder(data: PostData.CreateOrderData) {
    return post<ApiTypes.DataResult<ServerData.CreateOrderData>>(
      '/order/create',
      {},
      {
        ...data,
        slugCode: sessionStorage.getItem('slug_code'),
      }
    )
  }

  // 检查订单状态
  export function checkOrderStatus(outTradeNo: string) {
    return get<
      ApiTypes.DataResult<{
        status: 'created' | 'completed' | 'canceled' | 'waiting'
        paid: string
      }>
    >('/order/status', { outTradeNo })
  }
}
